import React from 'react';
import PageLayout from '../Layouts/PageLayout';

const TermsConditions = () => {
  return (
    <PageLayout title="Terms and Conditions">
      <div className="container mx-auto px-[35px] md:px-[60px] lg:px-[100px] text-[#444444]">
        <h1 className="text-[#B12929] font-bold text-3xl md:text-4xl mb-6 border-b-2 border-gray-200 pb-4">
          Terms and Conditions
        </h1>

        <div className="space-y-8 text-[17px] leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold mb-2 text-[#2c2c2c]">1. Introduction</h2>
            <p>
              These Terms and Conditions ("Agreement") govern your use of the Virat India Micro Finance website (https://rishta.money/) and the provision of consulting services. By accessing or using the website and engaging our services, you agree to be bound by these terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2 text-[#2c2c2c]">2. Services</h2>
            <p>
              Virat India Micro Finance offers professional consulting services in areas such as estate planning, business process restructuring, fintech consultancy, virtual CFO services, etc. The engagement terms for specific services will be mutually agreed upon before commencement.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2 text-[#2c2c2c]">3. Website Use</h2>
            <p>
              Users agree to use the website lawfully and not engage in activities that may harm, disrupt, or misuse the platform.
            </p>
            <p>
              Virat India Micro Finance grants a limited, non-exclusive, non-transferable license to use the content on the site solely for informational purposes.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2 text-[#2c2c2c]">4. Intellectual Property</h2>
            <p>
              All website content, trademarks, logos, and proprietary information are owned by Virat India Micro Finance or its licensors.
            </p>
            <p>
              Unauthorized use, reproduction, or distribution of site content is prohibited and may result in legal action.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2 text-[#2c2c2c]">5. Payment and Refunds</h2>
            <p>
              Payment terms for services will be outlined in individual service agreements.
            </p>
            <p>
              Refunds, if any, will be handled according to the company's Refund Policy available on the website.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2 text-[#2c2c2c]">6. Limitation of Liability</h2>
            <p>
              Virat India Micro Finance shall not be liable for any indirect, incidental, or consequential damages arising from the use of the website or services.
            </p>
            <p>
              While all efforts are made to ensure accuracy and reliability, no guarantees are made regarding outcomes from consultancy services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2 text-[#2c2c2c]">7. Privacy</h2>
            <p>
              Use of personal and business data is governed by our Privacy Policy, which is incorporated herein by reference.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2 text-[#2c2c2c]">8. Termination</h2>
            <p>
              Virat India Micro Finance reserves the right to suspend or terminate access to the website or services at its discretion, including violations of these terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2 text-[#2c2c2c]">9. Governing Law & Jurisdiction</h2>
            <p>
              This Agreement shall be governed by and construed under the laws of India. Any disputes shall be subject to the exclusive jurisdiction of courts in Gorakhpur, Uttar Pradesh.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2 text-[#2c2c2c]">10. Amendments</h2>
            <p>
              Virat India Micro Finance reserves the right to update or modify these Terms and Conditions at any time. Changes will be posted on the website and take immediate effect upon posting.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2 text-[#2c2c2c]">11. Contact</h2>
            <p>
              For questions regarding these terms, please contact{' '}
              <a href="mailto:viratindia2023@gmail.com" className="text-[#B12929] hover:underline">
                viratindia2023@gmail.com
              </a>
              .
            </p>
          </section>
        </div>
      </div>
    </PageLayout>
  );
};

export default TermsConditions;
